<div class="form-row">
  <div
    class="col-12"
    [ngClass]="{ 'col-md-6': isDesktop }"
    *ngIf="
      (formGroup.get('type').value === enumBondType.SINGLE_TRANSACTION || showSuretyCodeForContinuousBond) && formGroup.get('suretyCode')
    "
  >
    <app-control-wrapper [control]="formGroup.get('suretyCode')" [errors]="errors.suretyCode">
      <label for="suretyCode" control-label>{{ "FORM_LABEL.SURETYCODE" | translate }}</label>
      <input
        type="text"
        [formControl]="formGroup.get('suretyCode')"
        class="form-control"
        id="suretyCode"
        name="suretyCode"
        placeholder="{{ 'FORM_LABEL.SURETYCODE' | translate }}"
        [mask]="'0{3}'"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS'"
        [maxMaskLength]="3"
        [pattern]="integerInputMap.pattern"
        inputmode="decimal"
        control-wrapper
      />
    </app-control-wrapper>
  </div>
  <div
    class="col-12"
    [ngClass]="{ 'col-md-6': isDesktop }"
    *ngIf="
      formGroup.get('type').value === enumBondType.SINGLE_TRANSACTION && showRefNumberForContinuousBond && formGroup.get('referenceNumber')
    "
  >
    <app-control-wrapper [control]="formGroup.get('referenceNumber')" [errors]="errors.referenceNumber" helper="">
      <label for="referenceNumber" control-label>{{ "LABELS.REFERENCE_NUMBER" | translate }}</label>
      <input
        type="text"
        [formControl]="formGroup.get('referenceNumber')"
        class="form-control"
        id="referenceNumber"
        name="referenceNumber"
        placeholder="{{ 'LABELS.REFERENCE_NUMBER' | translate }}"
        [mask]="'A{9}'"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS'"
        [maxMaskLength]="9"
        control-wrapper
      />
    </app-control-wrapper>
  </div>
  <div class="col-12" [ngClass]="{ 'col-md-6': isDesktop }" *ngIf="formGroup.get('bondAmount')">
    <app-control-wrapper [control]="formGroup.get('bondAmount')" [errors]="errors.bondAmount">
      <label for="bondAmount" control-label>{{ "BOND_COVERAGE" | translate }}</label>
      <div control-wrapper class="currency-form-container">
        <input
          type="text"
          [formControl]="formGroup.get('bondAmount')"
          class="form-control currency"
          id="bondAmount"
          name="bondAmount"
          inputmode="numeric"
          [pattern]="currencyInputMap.pattern"
          [mask]="currencyInputMap.mask"
          [appMaskErrorTooltip]="currencyInputMap.maskErrorTooltip"
          [thousandSeparator]="currencyInputMap.thousandSeparator"
        />
        <div class="form-control currency-box">{{ DEFAULT_CURRENCY_CODE }}</div>
      </div>
    </app-control-wrapper>
  </div>
</div>
